import { CookieHeaderKeyMap } from '../../constants/cookie';

import type { GetServerSidePropsContext } from 'next';

/**
 * Set-Cookie 헤더를 전달된 쿠키 배열로 설정합니다.
 * @description
 * - 기존 헤더를 덮어씁니다.
 * @example
 * // burnContextCookies(context, ['KC_QUERY=...'])
 */
export const burnContextCookies = (
  context: Pick<GetServerSidePropsContext, 'res'>,
  cookies: string[],
) => {
  context.res.setHeader(CookieHeaderKeyMap.SET_COOKIE, cookies);
};
